/* jshint esversion: 6 */
/* jshint esversion: 11 */
/* jshint ignore:start */
import axios from 'axios';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { MdFemale, MdMale } from 'react-icons/md';
import { MyContext } from '../../Context/MyProvider';
import { IoCameraOutline } from 'react-icons/io5';
import { showToast } from '../../showTost';
import { useTranslation } from 'react-i18next';
import secureLocalStorage from "react-secure-storage";
const AddPatient = ({ Relation, BooldType, Data }) => {

    const { t } = useTranslation();
    const { ApiBaseUrl, ImgBaseUrl, setPatientStatus } = useContext(MyContext);


    const [addPatientData, setAddPatientData] = useState({ PatientName: "", Relationship: "", Relationshipid: "", BooldType: "", BooldTypeid: "", PatientGender: "", PatientAge: "", NationalID: "", Height: "", Weight: "", Allergies: "", MedicalHistory: "" });
    const [isFocused, setIsFocused] = useState(false);
    const [isFocused2, setIsFocused2] = useState(false);
    const [patientPhoto, setPatientphoto] = useState("");
    const [patientEditPhoto, setPatientEditphoto] = useState("");
    const [apiloading, setApiLoading] = useState(false);

    const Inputref = useRef(null);
    const wrapperRef = useRef(null);
    const wrapperRef2 = useRef(null);

    useEffect(() => {
        if (Data) {
            setPatientphoto(ImgBaseUrl + Data.profile_image);
            const Relationship = Relation.find((item) => item.id === Number(Data.relationship));
            const BooldTypeData = BooldType.find((item) => item.id === Number(Data.blood_type));
            setAddPatientData({
                PatientName: Data.name,
                Relationship: Relationship?.name,
                Relationshipid: Data.relationship,
                BooldType: BooldTypeData?.name,
                BooldTypeid: Data.blood_type,
                PatientGender: Data.gender,
                PatientAge: String(Data.patient_age),
                NationalID: Data.national_id,
                Height: Data.height,
                Weight: Data.weight,
                Allergies: Data.allergies,
                MedicalHistory: Data.medical_history
            });
        }
    }, [Data]);

    const validatePatientData = () => {
        for (let key in addPatientData) {
            if (String(addPatientData[key]).trim() === "") {
                return false;
            }
        }
        return true;
    };

    const SubmitHandle = () => {
        const Userid = secureLocalStorage.getItem("Userid");

        const Url = Data ? "/customer/edit_family_member" : "/customer/add_family_member";

        if (!patientPhoto) {
            showToast({ title: t("Add Patient Photo"), id: "warning" });
            return;
        }

        if (!validatePatientData()) {
            showToast({ title: t("Add Patient Details"), id: "warning" });
            return;
        }

        if (Userid) {

            setApiLoading(true);

            const formData = new FormData();

            formData.append("profile_image", patientEditPhoto);

            formData.append("customer_id", Userid);

            if (Data) {
                formData.append("fid", Data.id);
            }

            formData.append("name", addPatientData.PatientName);
            formData.append("relationship", addPatientData.Relationshipid);
            formData.append("blood_type", addPatientData.BooldTypeid);
            formData.append("gender", addPatientData.PatientGender);
            formData.append("patient_age", addPatientData.PatientAge);
            formData.append("national_id", addPatientData.NationalID);
            formData.append("height", addPatientData.Height);
            formData.append("weight", addPatientData.Weight);
            formData.append("allergies", addPatientData.Allergies);
            formData.append("medical_history", addPatientData.MedicalHistory);

            axios.post(`${ApiBaseUrl + Url}`, formData)
                .then((res) => {
                    const { ResponseCode, message } = res.data;
                    // console.log("family_member", res);
                    if (ResponseCode === 200) {
                        showToast({ title: message, id: "success" });
                        setPatientStatus("123");
                        setPatientphoto("");
                        setAddPatientData({ PatientName: "", Relationship: "", Relationshipid: "", BooldType: "", BooldTypeid: "", PatientGender: "", PatientAge: "", NationalID: "", Height: "", Weight: "", Allergies: "", MedicalHistory: "" });
                        setApiLoading(false);
                    }
                })
                .catch((error) => {
                    console.error(error);
                });
        }

    };

    const HandleRelationship = (e) => {
        if (addPatientData.Relationshipid) {
            setAddPatientData({ ...addPatientData, Relationship: e, Relationshipid: "" });
        } else {
            const selectedRelation = Relation.find(item => item.name.toLowerCase() === e.toLowerCase());
            const Id = selectedRelation && selectedRelation.id;
            setAddPatientData({ ...addPatientData, Relationship: selectedRelation ? selectedRelation.name : e, Relationshipid: Id });
        }
    };

    const HandleBooldType = (e) => {
        if (addPatientData.BooldTypeid) {
            setAddPatientData({ ...addPatientData, BooldType: e, BooldTypeid: "" });
        } else {
            const selectedRelation = BooldType.find(item => item.name.toLowerCase() === e.toLowerCase());
            const Id = selectedRelation && selectedRelation.id;
            setAddPatientData({ ...addPatientData, BooldType: selectedRelation ? selectedRelation.name : e, BooldTypeid: Id });
        }
    };

    useEffect(() => {

        const handleClickOutside = (event) => {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setIsFocused(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {

        const handleClickOutside = (event) => {
            if (wrapperRef2.current && !wrapperRef2.current.contains(event.target)) {
                setIsFocused2(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <div>
            <div className="photo-add">
                <div className="photo-box">
                    {patientPhoto
                        ? <img src={patientPhoto} className="w-full h-full object-cover" alt='patientPhoto' />
                        : <div className="w-full h-full bg-gray-200"></div>
                    }
                    <input ref={Inputref} type="file" className='hidden' onChange={(e) => { setPatientphoto(URL.createObjectURL(e.target.files[0])); setPatientEditphoto(e.target.files[0]) }} />
                </div>
                <button onClick={() => Inputref.current.click()} className="add-btn">{t("Add Photo")} <IoCameraOutline className='text-[20px]' /></button>
            </div>
            <div className="input-box">
                <div className="">
                    <h1 className='title'>{t("Patient Name")}</h1>
                    <input type="text" value={addPatientData.PatientName} onChange={(e) => setAddPatientData({ ...addPatientData, PatientName: e.target.value })} className='focus-within:border-[#0d4047] border-[2px] border-[#8080803b] input' placeholder={t('Patient Name')} />
                </div>

                <div className="flex items-center justify-between mt-[10px] gap-[5px]">

                    <div className="relative" ref={wrapperRef}>
                        <h1 className='title'>{t("Relationship")}</h1>
                        <input
                            onFocus={() => setIsFocused(true)}
                            value={addPatientData.Relationship}
                            onChange={(e) => HandleRelationship(e.target.value)}
                            type="text"
                            className='focus-within:border-[#0d4047] border-[2px] border-[#8080803b] input'
                            placeholder={t('Relationship Type')}
                        />
                        {isFocused && (
                            <div className="bg-white max-h-[280px] scroll-container rounded-[10px] p-[5px] drop-shadow-2xl absolute w-[100%] overflow-hidden z-10">
                                {Relation.map((item, index) => (
                                    <h1
                                        key={index}
                                        onClick={() => {
                                            setAddPatientData({ ...addPatientData, Relationship: item.name, Relationshipid: item.id });
                                            setIsFocused(false);
                                        }}
                                        className='font-[500] py-[5px] px-[10px] cursor-pointer hover:bg-gray-100'
                                    >
                                        {item.name}
                                    </h1>
                                ))}
                            </div>
                        )}
                    </div>

                    <div className="relative" ref={wrapperRef2}>
                        <h1 className='title'>{t("Blood Type")}</h1>
                        <input onFocus={() => setIsFocused2(true)} value={addPatientData.BooldType} onChange={(e) => HandleBooldType(e.target.value)} type="text" className='focus-within:border-[#0d4047] border-[2px] border-[#8080803b] input' placeholder={t('Blood Type')} />
                        {isFocused2 && <div className="bg-white max-h-[280px] scroll-container rounded-[10px] p-[5px] drop-shadow-2xl absolute w-[100%] overflow-hidden">
                            {BooldType.map((item, index) => {
                                return <h1 onClick={() => { setAddPatientData({ ...addPatientData, BooldType: item.name, BooldTypeid: item.id }); setIsFocused2(false); }} key={index} className='font-[500] py-[5px] px-[10px] cursor-pointer hover:bg-gray-100'>{item.name}</h1>
                            })}
                        </div>}
                    </div>
                </div>

                <div className="mt-[10px]">
                    <h1 className='title'>{t("Patient Gender")}</h1>
                    <div className="gender">
                        <button onClick={() => setAddPatientData({ ...addPatientData, PatientGender: "Male" })} className={`${addPatientData.PatientGender === "Male" ? "bg-[#0d4047] text-white" : "bg-[#8080803b]"} box rounded-s-[50px] border-e-[1px] border-[#8080803b]`}>
                            <MdMale className='text-[20px]' />
                            <h1 className='title'>{t("Male")}</h1>
                        </button>
                        <button onClick={() => setAddPatientData({ ...addPatientData, PatientGender: "Female" })} className={`${addPatientData.PatientGender === "Female" ? "bg-pink-500 text-white" : "bg-[#8080803b]"} box rounded-e-[50px]`}>
                            <MdFemale className='text-[20px]' />
                            <h1 className='title'>{t("Female")}</h1>
                        </button>
                    </div>
                </div>

                <div className="flex items-center justify-between mt-[10px] gap-[5px]">
                    <div className="">
                        <h1 className='title'>{t("Patient Age")}</h1>
                        <input type="number" value={addPatientData.PatientAge} onChange={(e) => setAddPatientData({ ...addPatientData, PatientAge: e.target.value })} className='focus-within:border-[#0d4047] border-[2px] border-[#8080803b] input' placeholder={t('Patient Age')} />
                    </div><div className="">
                        <h1 className='title'>{t("National ID")}</h1>
                        <input type="text" value={addPatientData.NationalID} onChange={(e) => setAddPatientData({ ...addPatientData, NationalID: e.target.value })} className='focus-within:border-[#0d4047] border-[2px] border-[#8080803b] input' placeholder={t('National ID')} />
                    </div>
                </div>

                <div className="flex items-center justify-between mt-[10px] gap-[5px]">
                    <div className="">
                        <h1 className='title'>{t("Height")}</h1>
                        <input type="number" value={addPatientData.Height} onChange={(e) => setAddPatientData({ ...addPatientData, Height: e.target.value })} className='focus-within:border-[#0d4047] border-[2px] border-[#8080803b] input' placeholder={t('Height')} />
                    </div><div className="">
                        <h1 className='title'>{t("Weight")}</h1>
                        <input type="number" value={addPatientData.Weight} onChange={(e) => setAddPatientData({ ...addPatientData, Weight: e.target.value })} className='focus-within:border-[#0d4047] border-[2px] border-[#8080803b] input' placeholder={t('Weight')} />
                    </div>
                </div>

                <div className="mt-[10px]">
                    <h1 className='title'>{t("Allergies")}</h1>
                    <input type="text" value={addPatientData.Allergies} onChange={(e) => setAddPatientData({ ...addPatientData, Allergies: e.target.value })} className='focus-within:border-[#0d4047] border-[2px] border-[#8080803b] input' placeholder={t('Allergies')} />
                </div>

                <div className="mt-[10px]">
                    <h1 className='title'>{t("Medical History")}</h1>
                    <input type="text" value={addPatientData.MedicalHistory} onChange={(e) => setAddPatientData({ ...addPatientData, MedicalHistory: e.target.value })} className='focus-within:border-[#0d4047] border-[2px] border-[#8080803b] input' placeholder={t('Medical History')} />
                </div>

                <button onClick={SubmitHandle} className='submit-btn'>
                    {apiloading
                        ? <div className="loader mx-auto"></div>
                        : <span>{t("SUBMIT")}</span>}
                </button>

            </div>
        </div>
    )
}

export default AddPatient
/* jshint ignore:end */